export { ActivitiesMessageComponent } from '@shared/layout/header/activities/activities-message/activities-message.component';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/activities/activities-message/index.ts